<p-table
    [columns]="cols"
    [value]="dataTable"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [scrollable]="true"
    [resizableColumns]="true"

    [(selection)]="selected"
    
    [dataKey]="dataKey"
    (onRowSelect)="isNotRowSelected=false"
    (onRowUnselect)="isNotRowSelected=true"

    [styleClass]="styleClass"
    [responsive]="true"
    responsiveLayout="stack"

    [paginator]="paginator" [lazy]="lazy" [(first)]="first" (onLazyLoad)="paginationEmitter($event)">

    <ng-template pTemplate="colgroup" let-columns>
		<colgroup class="p-datatable-tcolgroup">
            <div *ngFor="let col of columns">
                <div *ngIf="!col.hidden">
                    <col [style.width]="col.width">
                </div>
            </div>
		</colgroup>
	</ng-template>

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th scope="columna" *ngFor="let col of columns" pResizableColumn>
                <div *ngIf="!col.hidden">
                    {{col.header | translate}}
                </div>
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="index" >
            <td *ngFor="let col of columns" >
                <div *ngIf="!col.hidden">
                    <span class="p-column-title">{{col.header}}</span>
                    <div *ngIf="nombreColumna === col.field;else seleccionColumnaTemplate">
                        <span [ngClass]="{'status-disponible': rowData[col.field] === diponibleStatus, 'status-en-uso': rowData[col.field] === enUsoStatus, 'status-no-disponible': rowData[col.field] === noDisponibleStatus}">{{rowData[col.field]}}</span>
                    </div> 
                    <ng-template #seleccionColumnaTemplate>
                        <div *ngIf="seleccionColumna === col.field; else titlecasePipe">
                            <div [ngSwitch]="seleccionTipo">
                                <div *ngSwitchCase="'radio'">
                                    <form [formGroup]="selectForm" >
                                        <p-radioButton formControlName="seleccion" [(ngModel)]="idSeleccionado" [value]=rowData[dataKey] (click)=seleccionarFila(rowData[dataKey])> </p-radioButton> 
                                    </form>
                                </div>
                            </div>
                        </div>
                        <ng-template #titlecasePipe>
                            <div *ngIf="tipoPapeleria === col.field; else sinEstilo">
                                {{rowData[col.field] | titlecase}}
                            </div>
                            <ng-template #sinEstilo>
                                {{rowData[col.field] | checkEmpty}}
                            </ng-template>
                        </ng-template>
                    </ng-template>
                </div>
            </td>     
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
		<tr>
			<td [attr.colspan]="columns.length">
				{{'TABLA.sinresultados' | translate}}
			</td>
		</tr>
    </ng-template>
</p-table>
